import {field} from '../field'
import {mergeConfig} from '../../configStore'
import type {DatetimeField, FieldReturn} from '../../types'

export const datetime = (props?: DatetimeField, mergeProps?: Partial<DatetimeField>): FieldReturn =>
  field('datetime', mergeConfig('datetime', props, mergeProps))
